import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import BrandCard from "../components/BrandCard";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const Brands = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Scroll to top on load (standard behavior)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.search]);

  useEffect(() => {
    const fetchBrands = async () => {
        try {
            const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
            const response = await axios.get(`${BACKEND_URL}/api/brands`);
            setBrands(response.data);
        } catch (error) {
            console.error("Failed to fetch brands", error);
            toast.error("Could not load brand portfolio");
        } finally {
            setLoading(false);
        }
    };
    fetchBrands();
  }, []);

  return (
    <div className="bg-dreibach-black min-h-screen pb-24">
      <PageHeader 
        title="Our Brands & Products" 
        subtitle="A unified portfolio. Explore our brands and download the 2026 catalogs."
        image="https://images.unsplash.com/photo-1531973576160-7125cd663d86?auto=format&fit=crop&q=80&w=2000"
      />

      <div className="container mx-auto px-6 py-12">
        {loading ? (
            <div className="flex justify-center items-center h-64">
                <Loader2 className="w-12 h-12 text-dreibach-teal animate-spin" />
            </div>
        ) : (
            /* Simplified Grid - No Filters */
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {brands.map((brand) => (
                <BrandCard key={brand.id} brand={brand} />
            ))}
            </div>
        )}
      </div>
    </div>
  );
};

export default Brands;
